module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_ig-9463e0e9ded80576c088be2feb493ca6.svg&quot;;"